import { type SceneCompareItem, SceneType } from '@types';

/** 最大场景对比数 */
export const COMPARE_MAX = 500;

/** 场景对比项默认值 */
export const COMPARE_ITEM_DEFAULT: SceneCompareItem = {
  id: '',
  type: SceneType.pano,
  materialId: 0,
  title: '',
  viewOffset: {
    hLookAt: 0,
    vLookAt: 0,
    fov: 0,
  },
};

export const COMPARE_DIV_ID = 'compare-player';

export const COMPARE_ORIG = 'compare_orig';
export const COMPARE_TARGET = 'compare_target';
